import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import TextControl from "~components/shared/hook-form/controls/text-control"
import PhoneNumberControl from "~components/shared/hook-form/controls/phone-number-control"
import EmailControl from "~components/shared/hook-form/controls/email-control"
import { FORM_KEYS } from "~components/pages/listing/checkout/continue-as-guest-form/continue-as-guest-form-helpers"
import COPY from "~config/copy-constants"

interface Props {
    readonly isSingleColumn?: boolean
}

export default function GuestUserFormInputs({ isSingleColumn }: Props) {
    const styles = useStyles({ isSingleColumn })
    const formConfigs = useFormConfigs()

    return (
        <Box style={styles.root}>
            {formConfigs.map(({ Component, name, label, placeholder }) => (
                <Component
                    key={name}
                    name={name}
                    label={label}
                    placeholder={placeholder}
                    isRequired
                />
            ))}
        </Box>
    )
}

function useStyles({ isSingleColumn }: { isSingleColumn?: boolean }) {
    const gridLayout: StyleProps = {
        display: "grid",
        gap: "20px 16px",
        gridTemplateColumns: {
            base: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(1, 1fr)",
            lg: "repeat(2, 1fr)",
        },
    }
    const singleColumnLayout: StyleProps = {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    }

    return componentStyles({
        root: isSingleColumn ? singleColumnLayout : gridLayout,
        title: { marginBottom: 2 },
    })
}

function useFormConfigs() {
    return [
        {
            Component: TextControl,
            label: COPY.FIRST_NAME,
            name: FORM_KEYS.FIRST_NAME,
            placeholder: COPY.FIRST_NAME_PLACEHOLDER,
        },
        {
            Component: TextControl,
            label: COPY.LAST_NAME,
            name: FORM_KEYS.LAST_NAME,
            placeholder: COPY.LAST_NAME_PLACE_HOLDER,
        },
        {
            Component: EmailControl,
            label: COPY.EMAIL,
            name: FORM_KEYS.EMAIL,
            placeholder: COPY.EMAIL_PLACEHOLDER,
        },
        {
            Component: PhoneNumberControl,
            label: COPY.PHONE_NUMBER,
            name: FORM_KEYS.PHONE,
        },
    ]
}
